// extracted by mini-css-extract-plugin
export default {"image_avatar":"ImageItem_image_avatar__YM4Cq","image_item":"ImageItem_image_item__38jUj","is_whale":"ImageItem_is_whale__6udQa"};